import React from "react";
import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { tokens } from "../../theme/theme";
import { CHRISTMAS, FROST, HALLOWEEN, NIGHT, PIXEL_FONT, SPOOKY_FONT } from "../halloween/season";
import { Ghost } from "../halloween/sprites";
import Sprite from "../christmas/Sprite";
import { ICONS } from "../christmas/atlas";

export default function NotFoundPage() {
  return (
    <Container maxWidth="sm" sx={{ py: { xs: 8, md: 12 }, textAlign: "center" }}>
      {HALLOWEEN && (
        <Box className="hw-float" sx={{ width: 120, mx: "auto", mb: 1 }}>
          <Ghost style={{ display: "block", width: "100%", height: "auto" }} />
        </Box>
      )}
      {CHRISTMAS && (
        <Box className="xm-float" sx={{ display: "flex", justifyContent: "center", mb: 1 }}>
          <Sprite atlas={ICONS} name="snowman" />
        </Box>
      )}
      <Typography
        sx={
          CHRISTMAS
            ? {
                fontFamily: PIXEL_FONT,
                fontWeight: 400,
                fontSize: "4rem",
                lineHeight: 1,
                color: FROST.goldDeep,
                textShadow: "0 5px 0 " + FROST.redDeep,
              }
            : HALLOWEEN
            ? {
                fontFamily: SPOOKY_FONT,
                fontWeight: 400,
                fontSize: "5.5rem",
                lineHeight: 1,
                color: NIGHT.pumpkin,
                textShadow: "0 0 24px rgba(255,122,26,0.4)",
              }
            : {
                fontFamily: '"Manrope", sans-serif',
                fontWeight: 800,
                fontSize: "5rem",
                lineHeight: 1,
                color: tokens.blue100,
              }
        }
      >
        404
      </Typography>
      <Typography variant="h2" sx={{ mt: 1, mb: 1.5 }}>
        {HALLOWEEN
          ? "Цю сторінку забрали привиди"
          : CHRISTMAS
          ? "Цю сторінку замело снігом"
          : "Сторінку не знайдено"}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Можливо, посилання застаріло або в адресі є помилка.
        {HALLOWEEN && " А от квартири в каталозі — цілком справжні."}
        {CHRISTMAS && " Поки ми її відкопуємо — зазирніть у каталог."}
      </Typography>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="center">
        <Button component={RouterLink} to="/" variant="contained" size="large">
          На головну
        </Button>
        <Button component={RouterLink} to="/katalog" variant="outlined" size="large">
          Каталог квартир
        </Button>
      </Stack>
    </Container>
  );
}
